import { render, staticRenderFns } from "./TabWallpapers.vue?vue&type=template&id=39fd98ae&scoped=true&"
import script from "./TabWallpapers.vue?vue&type=script&lang=js&"
export * from "./TabWallpapers.vue?vue&type=script&lang=js&"
import style0 from "./TabWallpapers.vue?vue&type=style&index=0&id=39fd98ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fd98ae",
  null
  
)

export default component.exports